import {
  ExploreBaseFilterSchema,
  ExploreFilterComponentProps,
  ExplorePublishStatusFilterSchema,
} from "@modules/new-explore/types";
import ExploreSelectBox from "./explore-selectbox";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const ExplorePublishStatus: React.FC<ExploreFilterComponentProps> = () => {
  const { filtersData } = useExplorePreloadedData();

  return (
    <ExploreSelectBox
      filterName="publish_status"
      item={
        (
          filtersData?.publish_status as ExploreBaseFilterSchema &
            ExplorePublishStatusFilterSchema
        ).data
      }
    />
  );
};

export default ExplorePublishStatus;
